import React, { useRef } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import Button from "../../../componentsv2/Button";

export default function ModalPreviewAgendamentoPdf({
  open,
  loading,
  nomeArquivo,
  blobUrl,
  onClose,
  onDownload,
}) {
  const iframeRef = useRef(null);

  if (!open) return null;

  const handlePrint = () => {
    const janela = iframeRef.current?.contentWindow;
    if (!janela) return;

    janela.focus();
    janela.print();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ pr: 6 }}>
        {nomeArquivo}
        <IconButton
          aria-label="Fechar preview"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {loading && (
          <div style={{ minHeight: "420px", display: "grid", placeItems: "center" }}>
            Gerando PDF...
          </div>
        )}

        {!loading && blobUrl && (
          <iframe
            ref={iframeRef}
            src={blobUrl}
            title={`Visualizar ${nomeArquivo}`}
            style={{
              width: "100%",
              height: "72vh",
              border: "1px solid #ECEFF1",
              borderRadius: "8px",
            }}
          />
        )}

        {!loading && !blobUrl && (
          <div style={{ minHeight: "300px", display: "grid", placeItems: "center" }}>
            Não foi possível visualizar o PDF.
          </div>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button type="button" color="gray" variant="outlined" onClick={onClose}>
          Fechar
        </Button>
        <Button
          type="button"
          color="blue"
          variant="outlined"
          disabled={!blobUrl}
          onClick={handlePrint}
        >
          Imprimir
        </Button>
        <Button
          type="button"
          color="blue"
          variant="contained"
          disabled={!blobUrl}
          onClick={onDownload}
        >
          Baixar PDF
        </Button>
      </DialogActions>
    </Dialog>
  );
}
